import Event from '../../core/Event';
import { Month } from '../../../view/admin/getEstimationMonths';
import Product from '../../../domain/Product';

export default class EstimationChangeRequested extends Event {
    public static type = 'EstimationChangeRequested';

    constructor(
        public readonly product: Product,
        public readonly sku: string,
        public readonly variantCode: string,
        public readonly month: Month,
        public readonly value: number,
        public readonly shouldValidate: boolean
    ) {
        super(EstimationChangeRequested.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/estimations/events/EstimationChangeRequested.ts